import React from 'react';
import { useLocation } from 'react-router-dom';

import { CTL_ROUTES } from '../../../../navigation/paths';
import { quietBannerSlotSx } from '../../constants/layout';

import { HeldAlertsBanner } from './HeldAlertsBanner';

const SAYS_IT_ITSELF: ReadonlySet<string> = new Set([CTL_ROUTES.quietHours, CTL_ROUTES.recent]);

export const QuietBannerSlot: React.FC = () => {
  const { pathname } = useLocation();
  if (SAYS_IT_ITSELF.has(pathname)) return null;
  return <HeldAlertsBanner to={CTL_ROUTES.recent} sx={quietBannerSlotSx} />;
};
